import { Badge } from 'react-bootstrap';
import classes from './CapsuleButton.module.scss';

interface ICapsuleButton {
  label: string;
  onClickHandler: () => void;
  deleteIcon?: boolean;
  view?: boolean;
  edit?: boolean;
  ellipseLength: number;
  errEditStateForm?: boolean;
  className?: string;
}

const CapsuleButton = ({
  label,
  onClickHandler,
  deleteIcon = true,
  view = false,
  ellipseLength,
  edit = false,
  errEditStateForm = false,
  className = ''
}: ICapsuleButton) => (
  <Badge
    className={`${className} ${(!view || edit) && !errEditStateForm ? classes['cp-capsule-btn-wrapper'] : classes['cp-capsule-inactive']}`}
    text="dark"
    bg=""
  >
    <span className={label?.length > ellipseLength ? classes['cp-capsule-wrapped-title'] : classes['cp-capsule-title']} title={label} data-testid="capsule-label">
      {label}
    </span>
    {
      deleteIcon && (
        <span
          role="presentation"
          className={classes['cp-tag-icon']}
          onClick={onClickHandler}
          data-testid="capsule-delete-btn"
        >
          <i className="bi bi-x-circle-fill" />
        </span>)
    }
  </Badge>
);
export default CapsuleButton;
